import Class from '../tabs/legacy/legacy-class';

const Account = Class({
    init: function (preload) {
        this.update(preload);

        if (this.is_guest()) document.documentElement.className += ' guest-mode';
    },

    update: function (obj) {
        this.set(obj);
    },

    has_perm: function (perm) {
        if (this.is_superuser()) return true;
        return this.permissions().indexOf(perm) !== -1;
    },
})
    .implement(Class.EventSource)
    .implement(
        Class.Properties({
            id: {},
            username: {},

            fullname: {event: true},
            email: {event: true},
            email_confirmed: {event: true},

            is_demo: {},
            is_guest: {},
            is_staff: {},
            is_superuser: {},

            permissions: {value: []},

            guest_password_set: {event: true},

            allow_terminal: {},
            show_network_events: {},

            public_api_allowed: {},
            public_api_key: {},

            autoscan_system: {},

            asp_billing: {},
            real_account: {},
        })
    );

Account.has_perm = function (r_account, perm) {
    if (r_account.is_superuser) return true;
    return r_account.permissions.indexOf(perm) !== -1;
};

export default Account;
